import apiCompetitions from '@/api/competition-finances'

const state = {
  error: null,
  isSubmitting: false,
}

export const mutationTypes = {
  createCompetitionStart:
    '[create competition finance] Create competition start',
  createCompetitionSuccess:
    '[create competition finance] Create competition success',
  createCompetitionFailure:
    '[create competition finance] Create competition failure',
}

export const actionTypes = {
  createCompetition: '[create competition finance] Create competition',
}

const mutations = {
  [mutationTypes.createCompetitionStart](state) {
    state.isSubmitting = true
    state.error = null
  },

  [mutationTypes.createCompetitionSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.createCompetitionFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  },
}

const actions = {
  [actionTypes.createCompetition](context, {competition}) {
    context.commit(mutationTypes.createCompetitionStart)
    return new Promise((resolve) => {
      apiCompetitions
        .addCompetition(competition)
        .then((response) => {
          context.commit(mutationTypes.createCompetitionSuccess)
          resolve(response.data)
        })
        .catch((resolve) => {
          context.commit(
            mutationTypes.createCompetitionFailure,
            resolve.response.data.errors
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
